import { CircularProgress, TableCell, TableRow } from "@mui/material";
import styles from "./Styles/loginPageStyle.module.css";

interface UploadingItemRowProps {
  name: string;
}

/**
 * Placeholder row shown while a dropped model uploads and processes
 * asynchronously. Mirrors a real item row's anatomy — an empty select
 * column, then a shimmering preview slot where the render will land —
 * so the eye already knows where the finished part will appear.
 */
export default function UploadingItemRow({ name }: UploadingItemRowProps) {
  return (
    <TableRow className={styles.uploadingRow}>
      <TableCell sx={{ padding: 0 }} />
      <TableCell align="left">
        <div className={styles.uploadingPreview}>
          <CircularProgress
            size={26}
            thickness={4}
            sx={{ color: "var(--buttonYellow)" }}
          />
        </div>
      </TableCell>
      <TableCell align="left" colSpan={8}>
        <div className={styles.uploadingInfo}>
          <span className={styles.uploadingName}>{name}</span>
          <span className={styles.uploadingStatus}>
            Uploading &amp; preparing model…
          </span>
        </div>
      </TableCell>
    </TableRow>
  );
}
